export default {
    class: []
}